import httpClient from '@/lib/httpClient.js'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { toast } from 'sonner'

export default function useUnarchiveTransactionCategory() {
  const queryClient = useQueryClient()
  const action = async (id) => {
    return await httpClient.post(`/team/transaction-category/${id}/unarchive`)
  }

  return useMutation({
    mutationFn: action,
    onError: (e) => {
      toast.error(e?.response?.data?.message ?? 'An error occurred.')
    },
    onSuccess: (e) => {
      toast.success(
        e?.response?.data?.message ?? 'Transaction category has been unarchive',
      )
      queryClient.invalidateQueries({ queryKey: ['transaction-categories'] })
      queryClient.invalidateQueries({
        queryKey: ['transactions'],
      })
    },
  })
}
